export enum FeatureFlag {
  RedeemablesV2 = "dines.web.redeemables-v2-enabled",
  VoucherCodes = "dines.api.voucher-codes-enabled",
  Reports = "dines.api.reports-enabled",
  ReportingMaintenance = "dines.web.reporting-maintenance-enabled",
  Notifications = "dines.web.notifications-enabled",
  HideLinkedAccounts = "dines.web.org.hide-linked-accounts-enabled",
  HideGlobalMenus = "dines.web.org.hide-global-menus-enabled",
  HidePastOrders = "dines.web.org.hide-past-orders-enabled",
  HideReports = "dines.web.org.hide-reports-enabled",
  HideDevices = "dines.web.org.hide-devices-enabled",
  HideSettings = "dines.web.org.hide-settings-enabled",
}
